export default class FragmentsRenderer {
  static renderFragments(fragments) {
    const classNames = Object.keys(fragments);
    if (classNames.length) {
      classNames.forEach(className => {
        const fragment = fragments[className];
        if (typeof fragment === 'string') {
          for (const targetElement of document.querySelectorAll(className)) {
            targetElement.outerHTML = fragment;
          }
        } else {
          FragmentsRenderer.renderFragments(fragment);
        }
      });
    }
  }
}
